/*
 * 根据是否是微信手Q平台，解析不同的商详链接和通天塔活动链接
*/
var linkParser={
  isWQ: function () {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("micromessenger")!==-1 || ua.indexOf("qq/")!==-1) {
          return true;
      } else {
          return false;
      }
  },
  getUrlParam: function (link,name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var linkArr=link.split('?');
      if(linkArr.length>1){
        var r = link.split('?')[1].match(reg);
        if (r != null) return r[2];
      }
      return null;
  },
  parse: function(link){
    var me=this,
        sku=null,
        returnUrl=link;

    if(me.isWQ()){
      // 微信
      if(link.indexOf('//m.jd.com/product/')!==-1 || link.indexOf('//item.m.jd.com/')!==-1 || link.indexOf('//mitem.jd.hk')!==-1 || link.indexOf('//item.jd.hk')!==-1 || link.indexOf('//item.jd.com')!==-1){
        // 商详页
        var skuId=me.getUrlParam(link,'wareId');
        if(!skuId){
          var linkArr=link.split('/');
          skuId=linkArr[linkArr.length-1].split('.')[0];
        }
        return '//wqitem.jd.com/item/view?sku='+skuId
      }

      if(link.indexOf('//pro.m.jd.com')!==-1){
        //通天塔活动页
        return link.replace('/mall/','/wq/')
      }

      return link;

    }else{
      // 非微信
      return link;
    }
  }
  // ,
  // parseAreaLink: function($area){
  //   var me=this;
  //   var $links=$area.find('a');
  //   $links.each(function(){
  //     $link=$(this);
  //     $link.attr('href',me.parse($link.attr('href')));
  //   })
  // }
};

module.exports=linkParser;



// WEBPACK FOOTER //
// ./src/js/unit/linkParser/linkParser.js